<template>
  <div class="div">
    <!-- :before-close="handleClose" -->

    <div class="div-center" v-loading="loading">
      <el-tabs
        v-model="activeName"
        type="card"
        style="height: 100%"
        @tab-click="tabClick"
      >
        <el-tab-pane label="气耗分析" name="GasEcharts">
          <div class="div-top">
            <div>
              <span class="label">分析选项:</span>
              <el-radio-group v-model="searchData.SortType" @change="getEchartsData">
                <el-radio-button label="Amount">
                  <i class="icon icon-rmb1" style="font-size: 14px"></i>
                  金额分析</el-radio-button
                >
                <el-radio-button label="Qty">
                  <i class="icon icon-num" style="font-size: 14px"></i>
                  用量分析</el-radio-button
                >
              </el-radio-group>
              <div v-if="searchData.TimeType === 'Year'" style="display: inline-block">
                <span class="label">选择年份:</span>
                <span>
                  <el-date-picker
                    v-model="searchData.StartTimeYear"
                    type="year"
                    placeholder="开始年份"
                    value-format="yyyy"
                    :picker-options="startYearOptions"
                    style="width: 150px; text-align: center"
                    :clearable="false"
                    @change="getEchartsData"
                  >
                  </el-date-picker>
                  <span class="separator">至</span>
                  <el-date-picker
                    v-model="searchData.EndTimeYear"
                    type="year"
                    placeholder="结束年份"
                    :picker-options="endYearOptions"
                    value-format="yyyy"
                    :clearable="false"
                    @change="getEchartsData"
                    style="width: 150px; text-align: center"
                  >
                  </el-date-picker>
                </span>
              </div>
              <!-- <span class="label">时间选项:</span>
              <el-radio-group v-model="searchData.TimeType" @change="timeTypeChange">
                <el-radio-button label="Year">年份</el-radio-button>
                <el-radio-button label="YearMonth">年月</el-radio-button>
              </el-radio-group> -->
            </div>
            <div class="search-item" v-loading="buildingLoading">
              <div class="label">选择楼栋分类:</div>
              <el-checkbox-group
                v-model="searchData.Buildings"
                @change="BuildingsListChange"
              >
                <el-checkbox
                  v-for="item in BuildingsList"
                  :key="item.Id"
                  :label="item.Id"
                  :disabled="item.disabled"
                  >{{ item.Name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div class="search-item" v-loading="deviceTypeLoading">
              <div class="label">选择设备分类:</div>
              <el-checkbox-group
                v-model="searchData.DeviceTypes"
                @change="DeviceTypesListChange"
              >
                <el-checkbox
                  v-for="item in DeviceTypesList"
                  :key="item.Id"
                  :label="item.Id"
                  :disabled="item.disabled"
                  >{{ item.DicName }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <!-- <div class="search-item" v-if="searchData.TimeType === 'Year'">
              <div class="label">选择年份:</div>
              <div class="yearSelect">
                <el-date-picker
                  v-model="searchData.StartTimeYear"
                  type="year"
                  placeholder="开始年份"
                  :picker-options="startYearOptions"
                  value-format="yyyy"
                  :clearable="false"
                  @change="getEchartsData"
                  style="width: 150px; text-align: center"
                >
                </el-date-picker>
                <span class="separator">至</span>
                <el-date-picker
                  v-model="searchData.EndTimeYear"
                  type="year"
                  placeholder="结束年份"
                  :picker-options="endYearOptions"
                  value-format="yyyy"
                  :clearable="false"
                  @change="getEchartsData"
                  style="width: 150px; text-align: center"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="search-item" v-if="searchData.TimeType === 'YearMonth'">
              <div class="label">选择年月:</div>
              <el-date-picker
                v-model="searchData.searchYear"
                type="monthrange"
                :clearable="false"
                range-separator="至"
                value-format="yyyyMM"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                @change="getEchartsData"
              >
              </el-date-picker>
            </div> -->
          </div>

          <div class="echarts-container" v-loading="loading">
            <div class="dom-card">
              <div class="dom-card-title df aic jub">
                <span>气耗年度趋势</span>
                <span class="hint-text">
                  单位：（{{ searchData.SortType === "Qty" ? "方" : "元" }}）
                </span>
              </div>
              <EchartsDom
                type="bar"
                :data="echartsData.slist || []"
                width="100%"
                barWidth="50%"
                :thousand-separator="searchData.SortType === 'Qty' ? false : true"
                :grid="{
                  left: 60,
                  top: 40,
                  right: 40,
                  bottom: 30,
                }"
                legendTop="5px"
                height="220px"
              />
            </div>
            <div class="dom-card" style="margin-top: 10px">
              <div class="dom-card-title df aic jub">
                <span>按楼栋气耗年度趋势</span>
                <span class="hint-text">
                  单位：（{{ searchData.SortType === "Qty" ? "方" : "元" }}）
                </span>
              </div>
              <EchartsDom
                type="line2"
                :data="echartsData.blist || []"
                width="100%"
                :showArea="true"
                :labelPosition="'top'"
                :line2Smooth="true"
                :thousand-separator="searchData.SortType === 'Qty' ? false : true"
                :grid="{
                  left: 60,
                  top: 40,
                  right: 40,
                  bottom: 30,
                }"
                legendTop="5px"
                height="220px"
              />
            </div>
            <div class="dom-card" style="margin-top: 10px">
              <div class="dom-card-title df aic jub">
                <span>按专业设备气耗年度趋势</span>
                <span class="hint-text">
                  单位：（{{ searchData.SortType === "Qty" ? "方" : "元" }}）
                </span>
              </div>
              <EchartsDom
                type="line2"
                :data="echartsData.tlist || []"
                width="100%"
                :labelPosition="'top'"
                :showArea="true"
                :line2Smooth="true"
                :thousand-separator="searchData.SortType === 'Qty' ? false : true"
                :grid="{
                  left: 60,
                  top: 40,
                  right: 40,
                  bottom: 30,
                }"
                legendTop="5px"
                height="220px"
              />
            </div>
          </div>
          <div style="height: 20px"></div>
        </el-tab-pane>
        <el-tab-pane label="气耗明细数据" name="Gas">
          <el-row style="height: 40px">
            <el-date-picker
              v-model="DataInfo['Gas'].YearMonth"
              type="monthrange"
              align="right"
              format="yyyyMM"
              value-format="yyyyMM"
              unlink-panels
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
            >
            </el-date-picker>
            <el-button type="primary" @click="getInfo" style="margin-left: 10px"
              >查询</el-button
            >
            <el-button
              type="warning"
              @click="handleExport"
              style="margin-left: 10px"
              icon="el-icon-download"
              >导出数据</el-button
            >
          </el-row>
          <el-table
            :data="DataInfo['Gas'].tableData"
            ref="dialogTable"
            style="width: 100%"
            height="calc(100% - 90px)"
          >
            <el-table-column label="序号" width="50" type="index"> </el-table-column>

            <el-table-column
              label="年月"
              align="center"
              prop="iYearMonth"
              sortable
              width="120"
            >
            </el-table-column>
            <el-table-column label="设备编号" align="center" prop="DeviceCode" sortable>
            </el-table-column>
            <el-table-column label="设备名称" align="center" prop="DeviceName" sortable>
            </el-table-column>
            <el-table-column
              label="气消耗"
              align="center"
              prop="GasConsumptionQty"
              sortable
            >
              <template slot-scope="scope">
                {{
                  scope.row.GasConsumptionQty
                    ? JSON.parse(scope.row.GasConsumptionQty)
                    : ""
                }}
              </template>
            </el-table-column>
            <el-table-column label="平均价" align="right" prop="AvgPrice" sortable>
              <template slot-scope="scope">
                {{ tools.momenyFormat(scope.row.AvgPrice, 2) }}
              </template>
            </el-table-column>
            <el-table-column label="金额" align="right" prop="Amount" sortable>
              <template slot-scope="scope">
                {{ tools.momenyFormat(scope.row.Amount, 2) }}
              </template>
            </el-table-column>
          </el-table>
          <div
            style="
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: right;
            "
          >
            <el-pagination
              style="margin-top: 10px"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="DataInfo['Gas'].pagination.PageIndex"
              :page-sizes="DataInfo['Gas'].pagination.PageSizes"
              :page-size="DataInfo['Gas'].pagination.PageRows"
              layout="total, sizes, prev, pager, next, jumper"
              :total="DataInfo['Gas'].pagination.total"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import tools from "@/utils/tools.js";
import moment from "moment";
import { mapState } from "vuex";
import EchartsDom from "@/components/EchartsDom/EchartsDom.vue";

export default {
  data() {
    return {
      moment,
      tools,
      title: "",
      loading: false,
      activeName: "GasEcharts",
      RoleList: [],
      tableData: [],
      DataInfo: {
        Electricity: {
          YearMonth: "",
          tableData: [],
          pagination: {
            PageIndex: 1,
            PageRows: 20,
            PageSizes: [20, 40, 60, 100],
            total: 0,
          },
        },
        Gas: {
          YearMonth: "",
          tableData: [],
          pagination: {
            PageIndex: 1,
            PageRows: 20,
            PageSizes: [20, 40, 60, 100],
            total: 0,
          },
        },
        Water: {
          YearMonth: "",
          tableData: [],
          pagination: {
            PageIndex: 1,
            PageRows: 20,
            PageSizes: [20, 40, 60, 100],
            total: 0,
          },
        },
      },
      drawer: false,
      disabled: false,
      row: {},
      Year: "",
      chartData: [],
      monthChartData: [],
      searchData: {
        SortType: "Amount",
        TimeType: "Year",
        classType: "bui",
        StartTime: "",
        EndTime: "",
        DeviceTypes: [],
        Buildings: [],
        searchYear: [],
        StartTimeYear: "",
        EndTimeYear: "",
      },
      BuildingsList: [],
      DeviceTypesList: [],
      echartsData: { list: [] },
      deviceTypeLoading: false,
      buildingLoading: false,
      debouncedGetEchartsData: null,
    };
  },
  props: {},
  components: { EchartsDom },
  methods: {
    DeviceTypesListChange(a) {
      if (a.length === 1) {
        this.DeviceTypesList.find((item) => item.Id === a[0]).disabled = true;
      } else {
        this.DeviceTypesList.forEach((item) => {
          item.disabled = false;
        });
      }
      this.debouncedGetEchartsData();
    },
    BuildingsListChange(a) {
      if (a.length === 1) {
        this.BuildingsList.find((item) => item.Id === a[0]).disabled = true;
      } else {
        this.BuildingsList.forEach((item) => {
          item.disabled = false;
        });
      }
      this.debouncedGetEchartsData();
    },
    timeTypeChange() {
      if (this.searchData.TimeType === "Year") {
        if (!this.searchData.StartTimeYear || this.searchData.EndTimeYear) {
          this.searchData.StartTimeYear = moment().subtract(5, "years").format("YYYY");
          this.searchData.EndTimeYear = moment().format("YYYY");
        }
      } else if (this.searchData.TimeType === "YearMonth") {
        this.searchData.searchYear = [
          moment().startOf("year").format("YYYYMM"),
          moment().endOf("year").format("YYYYMM"),
        ];
      }
      this.getEchartsData();
    },
    async getBuildingDataList() {
      this.buildingLoading = true;
      await this.$http
        .post("/PB/PB_Project/GetProjectBuildingDataList", {})
        .then((res) => {
          this.buildingLoading = false;
          if (res.Success) {
            this.BuildingsList = res.Data || [];
            this.BuildingsList.forEach((item) => {
              this.$set(item, "disabled", false);
            });
            this.searchData.Buildings = this.BuildingsList.map((item) => item.Id);
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    async getProjectDeviceTypeList() {
      this.deviceTypeLoading = true;
      await this.$http.post("/PB/PB_Project/GetDevcieDictionaryMain", {}).then((res) => {
        this.deviceTypeLoading = false;
        if (res.Success) {
          this.DeviceTypesList = res.Data || [];
          this.DeviceTypesList.forEach((item) => {
            this.$set(item, "disabled", false);
          });
          this.searchData.DeviceTypes = this.DeviceTypesList.map((item) => item.Id);
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    handleExport() {
      let title = "";
      if (this.activeName === "Electricity") {
        title = "电消耗";
      } else if (this.activeName === "Water") {
        title = "水消耗";
      } else if (this.activeName === "Gas") {
        title = "气消耗";
      } else if (this.activeName === "Oil") {
        title = "油消耗";
      }

      tools.download(
        this.$rootUrl +
          `/PB/PB_Project/ConsumptionExportToExcel?DeviceType=${
            this.devTreeSearch.DeviceType || ""
          }&BuildingId=${this.devTreeSearch.BuildingId || ""}&InstallationArea=${
            this.devTreeSearch.InstallationArea || ""
          }&Type=${this.activeName}&YearMonth=${
            this.DataInfo[this.activeName].YearMonth?.length > 0
              ? this.DataInfo[this.activeName].YearMonth.join(",")
              : ""
          }`,
        title,
        ".xlsx",
        "get"
      );
    },
    handleCurrentChange(PageIndex) {
      this.DataInfo[this.activeName].pagination.PageIndex = PageIndex;
      this.getInfo();
    },
    handleSizeChange(PageRows) {
      this.DataInfo[this.activeName].pagination.PageRows = PageRows;
      this.getInfo();
    },

    getInfo() {
      this.loading = true;
      this.$http
        .post("/PB/PB_Project/GetConsumptionList", {
          // DeviceItemId: this.row.Id,
          PageIndex: this.DataInfo[this.activeName].pagination.PageIndex,
          PageRows: this.DataInfo[this.activeName].pagination.PageRows,
          Type: this.activeName,
          YearMonth:
            this.DataInfo[this.activeName].YearMonth?.length > 0
              ? this.DataInfo[this.activeName].YearMonth.join(",")
              : "",
          DeviceType: this.devTreeSearch.DeviceType || "",
          BuildingId: this.devTreeSearch.BuildingId || "",
          InstallationArea: this.devTreeSearch.InstallationArea || "",
        })
        .then((resJson) => {
          this.loading = false;
          if (resJson.Success) {
            this.DataInfo[this.activeName].tableData = resJson.Data?.Data;
            this.DataInfo[this.activeName].pagination.total = resJson.Data?.Total;
          } else {
            this.$notify.error(resJson.Msg);
          }
        });
    },
    close() {
      this.drawer = false;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    tabClick(tab) {
      this.activeName = tab.name;
      if (this.activeName === "GasEcharts") {
        this.getEchartsData();
      } else {
        this.getInfo();
      }
    },
    getEchartsData() {
      this.loading = true;
      if (this.searchData.TimeType === "Year") {
        this.searchData.StartTime = this.searchData.StartTimeYear;
        this.searchData.EndTime = this.searchData.EndTimeYear;
      } else if (this.searchData.TimeType === "YearMonth") {
        this.searchData.StartTime = this.searchData.searchYear[0];
        this.searchData.EndTime = this.searchData.searchYear[1];
      }
      this.$http
        .post("/PB/PB_Project/GetGasSummaryAnalysis", {
          SortType: this.searchData.SortType,
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.loading = false;
          if (res.Success) {
            this.echartsData = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
  },
  mounted() {},
  async created() {
    this.debouncedGetEchartsData = tools.debounce(function () {
      this.getEchartsData();
    }, 500);
    const currentDate = new Date();
    const currentMonth = this.$tools.timeFormat(currentDate, "YYYYMM");
    const previousMonth = this.$tools.timeFormat(
      new Date(currentDate.getFullYear(), 0, 1),
      "YYYYMM"
    );
    this.Year = [previousMonth, currentMonth];
    const sixMonthsAgo = this.$tools.timeFormat(
      new Date(currentDate.getFullYear(), 0, 1),
      "YYYYMM"
    );
    this.DataInfo["Gas"].YearMonth = [sixMonthsAgo, currentMonth];
    this.searchData.StartTimeYear = moment().subtract(5, "years").format("YYYY");
    this.searchData.EndTimeYear = moment().format("YYYY");
    this.searchData.searchYear = [
      moment().startOf("year").format("YYYYMM"),
      moment().endOf("year").format("YYYYMM"),
    ];
    this.loading = true;
    await this.getProjectDeviceTypeList();
    await this.getBuildingDataList();
    this.getEchartsData();
  },
  computed: {
    ...mapState(["devTreeSearch"]),
    startYearOptions() {
      return {
        disabledDate: (time) => {
          const year = time.getFullYear();
          // 如果结束年份已选择，开始年份需在 [结束年份-10, 结束年份] 范围内
          if (this.searchData.EndTime) {
            const end = parseInt(this.searchData.EndTime);
            return year > end || year < end - 10;
          }
          return false;
        },
      };
    },
    endYearOptions() {
      return {
        disabledDate: (time) => {
          const year = time.getFullYear();
          // 如果开始年份已选择，结束年份需在 [开始年份, 开始年份+10] 范围内
          if (this.searchData.StartTime) {
            const start = parseInt(this.searchData.StartTime);
            return year < start || year > start + 10;
          }
          return false;
        },
      };
    },
  },
  watch: {
    devTreeSearch() {
      if (this.activeName === "GasEcharts") {
        this.getEchartsData();
      } else {
        this.getInfo();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__content {
  height: calc(100% - 37px);
  .el-tab-pane {
    height: 100%;
    overflow-y: auto;
  }
}
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.div-center {
  height: calc(100%);
}
.tab-chart-container {
  width: 100%;
  height: 300px;
  min-height: 200px;
  box-sizing: border-box;
}
.tab-chart-pieList {
  width: 100%;
  height: 200px;
  min-height: 150px;
  box-sizing: border-box;
}
.pie-charts-container {
  display: flex;
  height: 100%;
  width: 100%;
  flex-wrap: wrap;
}
.pie-chart-item {
  width: calc(100% / 12);
  min-width: 80px;
  height: 100%;
  border-right: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
}
.pie-chart-item:last-child {
  border-right: none;
}
.chart-card {
  margin-bottom: 16px;
}
::v-deep .el-card__header {
  font-weight: bold;
}
@media (max-width: 1200px) {
  .pie-chart-item {
    width: calc(100% / 6);
  }
}
@media (max-width: 800px) {
  .pie-chart-item {
    width: calc(100% / 3);
  }
  .tab-chart-container {
    height: 220px;
  }
  .tab-chart-pieList {
    height: 120px;
  }
}

.label {
  font-size: 14px;
  font-weight: bold;
  margin-right: 20px;
  margin-left: 10px;
  display: inline-block;
  width: 100px;
  text-align: right;
}
.search-item {
  display: flex;
  align-items: center;
  margin: 10px 0;
  .el-checkbox-group {
    flex: 1;
  }
}
.yearSelect {
  display: flex;
  align-items: center;
  justify-content: center;

  .separator {
    font-size: 12px;
    margin: 0 10px;
  }
}
::v-deep .el-date-editor {
  .el-input__inner {
    text-align: center;
  }
}
.echarts-container {
  width: 100%;
}
</style>
